export default "__VITE_ASSET__Dm05U8WH__"